var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-estates-item-info-document"},[_c('ui-form',{attrs:{"model":_vm.selectedFields,"submit-handler":_vm.submitHandler,"validation":_vm.validation,"gap":"wide"},on:{"update":_vm.updateFormData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }